var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  padding: 1rem;\n  box-sizing: border-box;\n  background: #ffffff;\n  margin: 0;\n\n  @media (min-width: 600px) {\n    height: 372px;\n  }\n'], ['\n  height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  padding: 1rem;\n  box-sizing: border-box;\n  background: #ffffff;\n  margin: 0;\n\n  @media (min-width: 600px) {\n    height: 372px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import Message from './message';
import Loader from './loader';

var List = styled.ul(_templateObject);

var MessageList = function MessageList(_ref) {
  var messages = _ref.messages,
      loading = _ref.loading,
      children = _ref.children;
  return React.createElement(
    List,
    null,
    messages.map(function (m, i) {
      return React.createElement(Message, { message: m, key: i, index: i });
    }),
    children,
    React.createElement(Loader, { loading: loading })
  );
};

export default MessageList;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/index.js
// module id = 207
// module chunks = 1